/*
 * WHOSE SOFTWARE THIS IS — the copyright line, defined once.
 *
 * Shown quietly at the foot of the sign-in screen (every visitor, before they
 * are in) and in Settings beside the version. Kept here, in one place, so the
 * two never drift apart and the year is changed in a single edit.
 */
export const COPYRIGHT = '© 2026 Vinai Narace. All rights reserved.';
